import React, { useState } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';

const Item = ({ data, onClick, isOpen }) => (
  <div className={cn('item', isOpen && 'isOpen')}>
    <button
      className="item-title"
      onClick={e => {
        e.preventDefault();
        onClick();
      }}
    >
      <span>{data.title}</span>
      <motion.svg
        initial={{ rotate: 180 }}
        animate={{ rotate: isOpen ? 0 : 180 }}
        transition={{ duration: 0.35 }}
        width={12}
        height={6}
        fill="none"
      >
        <path
          d="M1.344 5.5a.416.416 0 01-.578-.016.335.335 0 01-.094-.28c0-.105.036-.194.11-.266l4.75-4.75A.636.636 0 016 0a.67.67 0 01.469.188l4.75 4.75a.416.416 0 010 .562.416.416 0 01-.281.11.38.38 0 01-.282-.11L6 .844 1.344 5.5z"
          fill="#EC7000"
        />
      </motion.svg>
    </button>

    <motion.div
      className="item-body"
      initial={{ height: 0 }}
      style={{ overflow: 'hidden' }}
      animate={{ height: isOpen ? '100%' : 0 }}
      transition={{ duration: 0.35 }}
    >
      <div style={{ marginBottom: 20 }}>{data.body}</div>
    </motion.div>

    <style jsx>{`
      .item {
        border-bottom: 1px solid #efe9e5;
      }

      .item.isOpen .item-title {
        color: #ec7000;
      }

      .item-title {
        cursor: pointer;
        width: 100%;
        border: 0;
        background: transparent;
        font: inherit;
        font-size: 18px;
        color: #231d19;
        padding: 16px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: left;
      }

      .item-title span {
        max-width: 95%;
      }

      .item-body {
        color: #757575;
        font-size: 16px;
      }
    `}</style>
  </div>
);

const Collapsibles = ({ items = [], ...rest }) => {
  const [collapsibles, setCollapsibles] = useState([].fill(false, 0, items.length));

  function toggle(i) {
    const copy = [...collapsibles];
    copy[i] = !collapsibles[i];
    setCollapsibles(copy);
  }

  return (
    <div className="collapsibles" {...rest}>
      {items.map((item, i) => (
        <Item key={i} data={item} onClick={() => toggle(i)} isOpen={collapsibles[i]} />
      ))}
    </div>
  );
};

export default Collapsibles;
